import { useGetMileageHistories } from '@/apis/rest/generated/hooks'
import { GetMileageHistoriesParams } from '@/apis/rest/generated/types'

export const useMileageHistories = (params?: GetMileageHistoriesParams) => {
  const { data, isLoading, isError, error, refetch, isFetching } = useGetMileageHistories(params, {
    query: {
      staleTime: 1000 * 60 * 1,
    },
  })

  return {
    histories: data?.data || [],
    totalCount: data?.page.totalCount || 0,
    pageInfo: data?.page || null,

    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  }
}
